import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../actions/navigationActions";
import * as settingsActions from "../../../../actions/settingsActions";
import * as rccActions from "../../../../actions/rccActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as rcc from "../../../../constants/rcc";
import * as resources from "../../../../constants/resources";
import * as formatHelper from "../../../../helpers/formatHelper";

import imgClean from "../../../../resources/img/svgicons/clean.svg";
import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Input from "../../../global/generic/Input";

class CleanAllChannelsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cleaningTime: this.props.cleaningTime
        };
    }

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleStartCleaningClick = () => {
        if (Number(this.state.cleaningTime) > 0) {
            this.props.dispatchCloseModalAction();
            this.props.dispatchCleanAllChannelsAction(Number(this.state.cleaningTime));
        }
    };

    handleCleaningTimeFocus = (event) => {
        event.target.select();
    };

    handleCleaningTimeChange = (event) => {
        if (validationHelper.isDecimalValueValid(event.target.value)) {
            this.setState({
                cleaningTime: validationHelper.formatDecimal(event.target.value)
            });
        }
    };

    handleCleaningTimeBlur = (event) => {
        let value = Number(event.target.value);

        if (!isNaN(value) && value >= rcc.RCC_MINIMAL_CLEAN_TIME) {
            this.setState({cleaningTime: formatHelper.formatDecimal(value)});
            this.props.dispatchSetCleaningTimeAction(parseInt(formatHelper.formatDecimal(value)));
        } else {
            this.setState({cleaningTime: rcc.RCC_MINIMAL_CLEAN_TIME});
            this.props.dispatchSetCleaningTimeAction(rcc.RCC_MINIMAL_CLEAN_TIME);
        }
    };

    getStartCleaningButton = () => {
        return (
            <Button
                onClick={this.handleStartCleaningClick}
                svgBefore={imgClean}
                label={<Translate value="serviceActionsSettings.cleanAllChannels" />}
                disabled={Number(this.state.cleaningTime) <= 0}
            />
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <div className="col-12">
                <div className="col-12 flex flex-wrap flex-align-center-vertical padding-bottom-10">
                    <div className="col-6 pull-left">
                        <Translate value="cleanChannels.cleaningTime" />
                    </div>
                    <Input
                        className="primary-input col-6"
                        type="text"
                        value={this.state.cleaningTime}
                        onFocus={this.handleCleaningTimeFocus}
                        onChange={this.handleCleaningTimeChange}
                        onBlur={this.handleCleaningTimeBlur}
                        disabled={this.props.loggedUser.canNotEdit(resources.SETTINGS_CLEANING_TIME)}
                        labelAfter={<span>s</span>}
                    />
                </div>
            </div>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getStartCleaningButton()}
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="cleanChannels.cleanAllChannels" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "30%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        cleaningTime: store.settings.cleaningTime,
        loggedUser: store.login.loggedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CLEAN_ALL_CHANNELS_MODAL));
        },
        dispatchCleanAllChannelsAction: (cleaningTime) => {
            dispatch(rccActions.cleanAllChannels(cleaningTime));
        },
        dispatchSetCleaningTimeAction: (cleaningTime) => {
            dispatch(settingsActions.setCleaningTime(cleaningTime));
        }
    };
};

export default CleanAllChannelsModal = connect(mapStoreToProps, mapDispatchToProps)(CleanAllChannelsModal);
